import PropTypes from 'prop-types';
import { useEffect } from "react"
import { m } from 'framer-motion';
// @mui
import {Button, Container, Typography} from '@mui/material';
// hooks
import useAuth from '../hooks/useAuth';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { ForbiddenIllustration } from '../assets';
import {useDispatch, useSelector} from "../redux/store";
import LoadingScreen from "../components/LoadingScreen";
import {setAdminHasAccess, setCountPlus} from "../redux/slices/user";
import {useSnackbar} from "notistack";
import { BLOCKED_ROLE_UUID, REGISTER_ROLE_UUID, USER_ROLE_UUID } from 'src/constants/user-role-constants';
import {PATH_AUTH} from "../routes/paths";
import {useNavigate} from "react-router-dom";

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  hasContent: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.string), // Example ['admin', 'leader']
  children: PropTypes.node.isRequired,
};

export default function RoleBasedGuard({ hasContent, roles, children }) {
  // Logic here to get current user role
    const {enqueueSnackbar} = useSnackbar();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { googleSignOut } = useAuth();
    const {userRole, isInitialized, userAdditionalInfo, isAgencyUser, adminHasAccess} = useSelector((state) => state.user);
    if(userRole == USER_ROLE_UUID){
      let module = import('../../src/freshchat');
    }
    const redirectUrl = localStorage.getItem("redirectTo")

    useEffect(()=> {
        if (!adminHasAccess) {
            enqueueSnackbar("You do not have access to do this.",{ variant: 'error' })
            setTimeout(()=> {
                dispatch(setAdminHasAccess(true))
            }, 1000)
        }
    }, [adminHasAccess])

    if (window.location.href.includes("redirectTo") && typeof roles !== 'undefined' && !roles.includes(userRole)) {
      localStorage.setItem("redirectTo", window.location.href.substring(window.location.href.indexOf("redirectTo")))
      window.location.href = "/"
      return
    }

    if (userRole === BLOCKED_ROLE_UUID) {
        googleSignOut()
        return
    }

    if (!isInitialized) {
        return <LoadingScreen />
    }

  if (typeof roles !== 'undefined' && !roles.includes(userRole)) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Permission Denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>You do not have permission to access this page</Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
        <Button color="warning" variant="outlined" onClick={() => {
            googleSignOut()
            navigate(PATH_AUTH.login, { replace: true });
        }}>Sign-out</Button>
      </Container>
    ) : null;
  }

  if (redirectUrl && typeof roles !== 'undefined' && userRole !== REGISTER_ROLE_UUID) {
    if (redirectUrl.includes("JobId")) {
      localStorage.removeItem("redirectTo")
      localStorage.setItem("redirectToJobId", redirectUrl)
      window.location.href = "/user/job-list"
      return
    }
  }

  // SPAG-5334: Payment/billing fields are removed from the Evaluate vendor profile UI, so Evaluate profile
  // completeness should be based only on the extended questionnaire fields below (not billingInfos).
    const extendedProfileComplete =
        userAdditionalInfo &&
        userAdditionalInfo.speaksFirst &&
        userAdditionalInfo.learnEnglishAge &&
        userAdditionalInfo.speaksHome &&
        (userAdditionalInfo.yearsCurrentCountry || userAdditionalInfo.yearsCurrentCountry === 0) &&
        (userAdditionalInfo.familyMembers || userAdditionalInfo.familyMembers === 0) &&
        userAdditionalInfo.havePets &&
        userAdditionalInfo.cityBorn &&
        userAdditionalInfo.stateBorn &&
        userAdditionalInfo.countryBorn &&
        userAdditionalInfo.mostCountryLive &&
        userAdditionalInfo.educationLevel &&
        userAdditionalInfo.gender &&
        userAdditionalInfo.race &&
        userAdditionalInfo.exposeContent &&
        (userAdditionalInfo.workExperienceArray && userAdditionalInfo.workExperienceArray.length > 0) &&
        (userAdditionalInfo.experienceArray && userAdditionalInfo.experienceArray.length > 0);

    if (
        !isAgencyUser &&
        userRole === USER_ROLE_UUID &&
        !extendedProfileComplete &&
        !window.location.href.includes("/user/user/account")
    ) {
        localStorage.setItem("profileEmpty", "true")
        window.location.href = "/user/user/account"
        return
    }

  return <>{children}</>;
}
